"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimestampMap = void 0;
const Timestamp_1 = require("../domain/Timestamp");
const Mapper_1 = require("../infra/Mapper");
class TimestampMap extends Mapper_1.Mapper {
    static toDomain(raw) {
        const domainObject = raw ? Timestamp_1.Timestamp.create(Number.parseInt(raw)) : Timestamp_1.Timestamp.create(raw);
        return domainObject;
    }
    static toDTO(d) {
        const res = d.value;
        return res;
    }
}
exports.TimestampMap = TimestampMap;
//# sourceMappingURL=TimestampMap.js.map